import imageUrlBuilder from '@sanity/image-url'
import {sanityClient} from './client'

const builder = imageUrlBuilder(sanityClient)

export function urlFor(source) {
  try {
    return builder.image(source).auto('format').fit('max').url()
  } catch {
    return ''
  }
}

